import { render, staticRenderFns } from "./AssignLicenseModal.vue?vue&type=template&id=defd60c0&scoped=true&"
import script from "./AssignLicenseModal.vue?vue&type=script&lang=js&"
export * from "./AssignLicenseModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignLicenseModal.vue?vue&type=style&index=0&id=defd60c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defd60c0",
  null
  
)

export default component.exports